import './Portfolio.css';
import 'react-simple-hook-modal/dist/styles.css';
import React from 'react';
import Rabeya from './Sites/Rabeya';
import {ModalProvider} from 'react-simple-hook-modal';
import Serviceboy from './Serviceboy';
import Paperback from './Paperback';
import Raufuchat from './Raufuchat';
import Rabeyasm from './sm-sites/Rabeyasm';
import Paperbacksm from './sm-sites/Paperbacksm';
import Serviceboysm from './sm-sites/ServiceBoysm';
import Raufuchatsm from './sm-sites/Raufuchatsm';

const Portfolio = () => {

      return (
            <section className='portfolio-container mt-5'>

                  <div className="container">
                        <div data-aos="fade-right" className="row">

                              <h2 className='brand brand-link link'>My Portfolio</h2>

                              <div className="col-md-10">
                                    <p className='text-muted mt-3 fs-5'>A small gallery of recent projects chosen by me. I've done them all alone. It's only a drop in the ocean compared to the entire list.
                                    Interested to see some more? Visit <a className='brand brand-link text-decoration-none' href="/projects">my work</a> page.
                                    </p>
                              </div>

                              <div className="col-md-2 mt-5">
                                    <a href="/projects">
                                          <button className='btn hvr-sweep-to-right mb-5'>See more!</button>
                                    </a>
                              </div>

                        </div>

                  </div>

                  <ModalProvider>
                        <div style={{ width: '100vw' }} className="container d-none d-sm-block mt-5">
                              <div className="row">
                                    <Rabeya />
                                    <Serviceboy />
                                    <Paperback />
                                    <Raufuchat />
                              </div>

                        </div>

                        <div className="container d-sm-none d-md-none">
                              <div className="row">
                                    <Rabeyasm />
                                    <Serviceboysm />
                                    <Paperbacksm />
                                    <Raufuchatsm />
                              </div>
                        </div>

                  </ModalProvider>

            </section>
      );
};

export default Portfolio;